module.exports = __webpack_public_path__ + "media/footer/google-play-c89fb399.svg";